// One coherent inline stroke-icon set (DESIGN.md: no emoji-as-icons). Paths ported from the
// approved mockups. viewBox 24, stroke=currentColor. Size via CSS on the parent/className.

export type IconName =
  | 'dashboard' | 'composer' | 'sessions' | 'targets' | 'analytics' | 'activity' | 'settings'
  | 'send' | 'chevronDown' | 'chevronEnd' | 'check' | 'checkDouble' | 'eye' | 'users' | 'phone'
  | 'download' | 'bolt' | 'clock' | 'moon' | 'sun' | 'search' | 'sparkles' | 'retry' | 'calendar'
  | 'repeat' | 'wa' | 'status' | 'channel' | 'telegram' | 'x' | 'image' | 'bold' | 'italic'
  | 'list' | 'variable' | 'spin' | 'optout' | 'plus' | 'close' | 'guide';

const P: Record<IconName, JSX.Element> = {
  dashboard: (<><rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" /><rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" /></>),
  composer: (<><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" /></>),
  sessions: (<><rect x="5" y="2" width="14" height="20" rx="2.5" /><path d="M12 18h.01" /></>),
  targets: (<><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" /></>),
  analytics: (<><path d="M3 3v18h18" /><path d="M7 15l4-5 3 3 5-7" /></>),
  activity: (<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M9 13h6M9 17h4" /></>),
  settings: (<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-2.82 1.17V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 3.6 15H3.5a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 5 9.4" /></>),
  send: (<><path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4z" /></>),
  chevronDown: (<path d="M6 9l6 6 6-6" />),
  chevronEnd: (<path d="M9 6l6 6-6 6" />),
  check: (<path d="M20 6 9 17l-5-5" />),
  checkDouble: (<><path d="M18 6 9.5 15 5 10.5" /><path d="M23 6l-8.5 9" /></>),
  eye: (<><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></>),
  users: (<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /></>),
  phone: (<><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M12 18h.01" /></>),
  download: (<><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="M7 10l5 5 5-5" /><path d="M12 15V3" /></>),
  bolt: (<path d="M13 2 3 14h9l-1 8 10-12h-9z" />),
  clock: (<><path d="M12 8v4l3 2" /><circle cx="12" cy="12" r="9" /></>),
  moon: (<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />),
  sun: (<><path d="M12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" /><circle cx="12" cy="12" r="4" /></>),
  search: (<><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>),
  sparkles: (<path d="m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />),
  retry: (<><path d="M23 4v6h-6" /><path d="M20.5 14a9 9 0 1 1-2.1-9.4L23 10" /></>),
  calendar: (<><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>),
  repeat: (<><path d="M17 2l4 4-4 4M21 6H7a4 4 0 0 0-4 4v1M7 22l-4-4 4-4M3 18h14a4 4 0 0 0 4-4v-1" /></>),
  wa: (<><path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M8 7a4 4 0 1 0 8 0 4 4 0 0 0-8 0M17 11a4 4 0 0 0 4 4" /></>),
  status: (<><circle cx="12" cy="12" r="9" strokeDasharray="4 3" /><circle cx="12" cy="12" r="3" /></>),
  channel: (<><path d="M3 11l18-7v16l-7-2.5" /><path d="M3 11v4l4 1M7 16v4l3-1" /></>),
  telegram: (<path d="M22 3 2 10l6 2 2 6 3-4 5 3z" />),
  x: (<path d="M4 4l16 16M20 4 4 20" />),
  image: (<><path d="M21 15V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14l4-4 4 3 5-5 5 4z" /><circle cx="8.5" cy="8.5" r="1.5" /></>),
  bold: (<path d="M6 4h8a4 4 0 0 1 0 8H6zM6 12h9a4 4 0 0 1 0 8H6z" />),
  italic: (<path d="M19 4h-9M14 20H5M15 4 9 20" />),
  list: (<path d="M4 7h16M4 12h16M4 17h10" />),
  variable: (<path d="M8 3H7a2 2 0 0 0-2 2v4l-2 3 2 3v4a2 2 0 0 0 2 2h1M16 3h1a2 2 0 0 1 2 2v4l2 3-2 3v4a2 2 0 0 1-2 2h-1" />),
  spin: (<path d="M16 3h5v5M4 20 21 3M21 16v5h-5M15 15l6 6M4 4l5 5" />),
  optout: (<><path d="M18.36 6.64A9 9 0 1 1 5.64 6.64" /><path d="M12 2v10" /></>),
  plus: (<path d="M12 5v14M5 12h14" />),
  close: (<path d="M18 6 6 18M6 6l12 12" />),
  guide: (<><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v15H6.5A2.5 2.5 0 0 0 4 19.5z" /><path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20" /><path d="M8 7h8M8 11h5" /></>),
};

export function Icon({ name, className }: { name: IconName; className?: string }): JSX.Element {
  // Default to 1em (text-sized) + no-shrink so an icon without a sizing className NEVER balloons to
  // fill a flex/grid cell. A className (e.g. .mark) still overrides via CSS. width/height are
  // attributes (not inline style) precisely so CSS wins when a caller wants a bigger icon.
  return (
    <svg
      viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth={2}
      strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true"
      style={{ flex: 'none' }}
    >
      {P[name]}
    </svg>
  );
}
